import styled from 'styled-components/macro';

import { colors, sizes } from '../../styles/vars';

const Wrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${sizes.controlsWidth};
  justify-content: space-between;
  border-left: 1px solid ${colors['pale-grey']};
`;

export default Wrapper;
